/* eslint-disable import/first */

// ===== CSS: Bootstrap 5 + Font Awesome + AdminLTE v4 =====
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "admin-lte/dist/css/adminlte.min.css";

// ===== JS: jQuery + Bootstrap 5 + AdminLTE v4 =====
import $ from "jquery";
(window as any).$ = (window as any).jQuery = $;

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "admin-lte/dist/js/adminlte.min.js";

// ===== CSS riêng của app =====
import "./index.css";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { store } from "./store/store";
import { muiTheme } from "./theme";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <Provider store={store}>
        <MuiThemeProvider theme={muiTheme}>
            <App />
        </MuiThemeProvider>
    </Provider>
);

reportWebVitals();
